module.exports = __webpack_public_path__ + "staticcomp/img/top.2becc04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/top.jpg
// module id = 4iJm
// module chunks = 39